import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
} from "@mui/material";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { persistor, resetStore } from "../../../_redux/../store";
import { sessionExpired } from "../../../_redux/_apiHelpers/_apihelper";
import { getCustomMessagesAsync } from "../../../_redux/_services/UserManagerSlice";
import { updateAuth } from "../../../_redux/AuthSlice";
import { updateLoader } from "../../../_redux/LoaderSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { authService } from "../../../api/authApi";
import Loader from "../../../components/Loader/Loader";
import MessageBar from "../../../components/SnackBar/MessageBar";
import { Loginillu } from "../../../Icons/Loginillu";
import { UserIcon3 } from "../../../Icons/userIcon3";
import { fetchATSThemeConfig } from "../../../_redux/_services/ThemeSlice";
import "./Login.css";

const Login = () => {
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const showLoader = useSelector((state) => state.Loader.value);
  const showMessage = useSelector((state) => state.Snackbar.message);
  const showMsgType = useSelector((state) => state.Snackbar.type);
  const [serviceErrorMsg, setServiceErrorMsg] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [customMessage, setCustomMessage] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const { themeSettings } = useSelector((state) => state.theme);

  const GetCustomMessages = useSelector(
    (state) => state.GetCustomMessages.data,
  );

  const [isLogoLoading, setIsLogoLoading] = useState(true);
  const DEFAULT_LOGO =
    process.env.PUBLIC_URL + "/assests/img/Hirewing-logo.png";
  const DefaultTheme = {
    primaryColor: "#FFD800",
    primaryFontColor: "#3B4046",
    secondaryColor: "#3B4046",
    secondaryFontColor: "#FFFFFF",
    fontFamily: '"Roboto", sans-serif',
    logo: process.env.PUBLIC_URL + "/assests/HireWing.png",
  };

  const initialPasswordState = {
    isPromptOpen: false,
    userDetails: null,
    newPassword: "",
    confirmPassword: "",
    passwordPattern: "",
    error: "",
  };
  const [logoUrl, setLogoUrl] = useState("");
  const [appTheme, setTheme] = useState({});

  useEffect(() => {
    const storedTheme = localStorage.getItem("themeSettings");
    if (storedTheme && Object.keys(storedTheme)?.length > 0) {
      const parsedTheme = JSON.parse(storedTheme);
      setTheme(parsedTheme);

      if (parsedTheme?.logo || themeSettings?.logo?.trim() !== "") {
        setLogoUrl(parsedTheme?.logo);
      } else {
        setLogoUrl(DEFAULT_LOGO);
      }
    } else {
      setLogoUrl(DEFAULT_LOGO);
      setTheme(DefaultTheme);
    }
    setIsLogoLoading(false);

    let customMessage = Cookies.get("loginMessage");
    if (customMessage && customMessage !== "undefined") {
      //  console.log(JSON.parse(customMessage));
      const resultObject = {};
      JSON.parse(customMessage)?.forEach((item) => {
        resultObject[item.heading.toLowerCase()] = item.data;
      });
      setCustomMessage(resultObject);
    }
  }, []);

  const location = useLocation();

  const [userDetails, setUserDetails] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [resetPasswordState, setResetPasswordState] = useState(
    JSON.parse(JSON.stringify(initialPasswordState)),
  );

  const handleResetPasswordOpen = () => {
    dispatch(updateLoader(false));
    setResetPasswordState({ ...initialPasswordState, isPromptOpen: true });
  };

  const handleResetPasswordClose = () => {
    setUserDetails({ ...userDetails, username: "", password: "" });
    setResetPasswordState({ ...initialPasswordState, isPromptOpen: false });
  };

  const updateResetPasswordError = (error) => {
    setResetPasswordState({ ...resetPasswordState, error });
  };

  useEffect(() => {
    // Check for session expired message from previous redirect
    const sessionExpiredMsg = sessionStorage.getItem("sessionExpiredMsg");
    if (sessionExpiredMsg) {
      dispatch(updateSnackbar({ type: "error", message: sessionExpiredMsg }));
      sessionStorage.removeItem("sessionExpiredMsg");
    }
  }, [location]);

  // const handleResetPassword = async () => {
  //   const userInfo = await getUserDetails()
  //   try {
  //     if (resetPasswordState.newPassword === resetPasswordState.confirmPassword) {
  //       dispatch(completePasswordChallenge(resetPasswordState.newPassword, resetPasswordState.userDetails)).then(res => {
  //         dispatch(updateSnackbar({ type: 'success', message: "Password updated successfully !!!" }));
  //         handleResetPasswordClose()
  //         dispatch(updateAuth(userInfo))
  //         handleResetPasswordClose();
  //       })
  //       // navigate("/ats/layout/jobpostings/landing");
  //     } else {
  //       updateResetPasswordError("Password doesn't match !!!")
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     updateResetPasswordError(error.message)
  //   }
  // }

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      if (
        resetPasswordState.passwordPattern === "" &&
        resetPasswordState.error === "" &&
        resetPasswordState.confirmPassword !== "" &&
        resetPasswordState.newPassword !== ""
      ) {
        dispatch(updateLoader(true));
        await authService.completePasswordChallenge(
          resetPasswordState.newPassword,
          userDetails.username,
        );
        dispatch(updateLoader(false));
        dispatch(
          updateSnackbar({
            type: "success",
            message: "Password updated successfully",
          }),
        );
        handleResetPasswordClose();
      } else if (
        resetPasswordState.confirmPassword !== "" &&
        resetPasswordState.newPassword !== ""
      ) {
        dispatch(
          updateSnackbar({ type: "error", message: "Password doesn't match" }),
        );
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "Password is Required" }),
        );
      }
    } catch (error) {
      dispatch(updateLoader(false));
      console.log(error);
      dispatch(
        updateSnackbar({
          type: "error",
          message: error.response?.data?.message || "Failed to update password",
        }),
      );
    }
  };

  let emailRegex = /^[a-zA-Z0-9_!#$%&*+/=?`{}~^.-]+@[a-zA-Z0-9.-]+$/;

  const validationSchema = Yup.object({
    username: Yup.string()
      .email("Please enter a valid E-mail address")
      .required("Please enter a valid E-mail ID")
      .matches(emailRegex, "Invalid E-mail format"),
    password: Yup.string().required("Please enter a valid passsword"),
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/, " "),
  });

  const formik = useFormik({
    initialValues: userDetails,
    validationSchema,
    onSubmit: async (values) => {
      handleSubmit();
      // dispatch(_ser.loginPageAsync(values));
    },
  });

  // const onConfirmpasswordHandler = (value, name, obj) => {
  //   if (name === 'newPassword') {
  //     // let passwordRegex = /^[a-zA-Z0-9_!#$%&*+/=?`{}~^.-]+@[a-zA-Z0-9.-]+$/;
  //     let passwordRegex =
  //       /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
  //     if (value.match(passwordRegex)) {
  //       obj.passwordPattern = '';
  //     } else {
  //       obj.passwordPattern =
  //         'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character';
  //     }
  //   } else if (name === 'confirmPassword') {
  //     if (obj.newPassword === value) {
  //       obj.error = '';
  //     } else {
  //       obj.error = "Password doesn't match";
  //     }
  //   }
  //   obj[name] = value;
  //   setResetPasswordState({ ...resetPasswordState, obj });
  // };
  const onConfirmpasswordHandler = (value, name) => {
    setResetPasswordState((prev) => {
      const updated = { ...prev };

      if (name === "newPassword") {
        // password pattern validation
        const passwordRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
        updated.passwordPattern = passwordRegex.test(value)
          ? ""
          : "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character";
        updated.newPassword = value;

        // re-check confirmPassword match if present
        if (updated.confirmPassword && updated.confirmPassword !== value) {
          updated.error = "Password doesn't match";
        } else {
          updated.error = "";
        }
      } else if (name === "confirmPassword") {
        updated.confirmPassword = value;
        updated.error =
          updated.newPassword === value ? "" : "Password doesn't match";
      } else {
        updated[name] = value;
      }

      return updated;
    });
  };
  const handleSubmit = async () => {
    const { username, password } = userDetails;

    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar({ type: "", message: "" }));

      const response = await authService.login(username, password, remember);
      const msg = String(response?.message || "").toLowerCase();
      if (
        msg.includes("password step1") ||
        msg.includes("password step 1") ||
        msg.includes("step1")
      ) {
        dispatch(
          updateSnackbar({
            type: "success",
            message: response?.message || "Please reset your password",
          }),
        );
        // open reset prompt and pass username (so you can complete password challenge)
        setResetPasswordState((prev) => ({
          ...prev,
          isPromptOpen: true,
          userDetails: username,
          newPassword: "",
          confirmPassword: "",
          error: "",
        }));
        dispatch(updateLoader(false));

        // stop further login flow
        return;
      }
      dispatch(
        updateSnackbar({
          type: "success",
          message: response?.message || "Login successful",
        }),
      );
      if (response.code && response.userDetails.length > 0) {
        const userData = response.userDetails;
        sessionStorage.setItem("DashboardConfig", userData[0].dashboardConfig);
        let integrations = [];
        try {
          if (userData[0]?.integrations) {
            integrations = JSON.parse(userData[0].integrations);
          }
        } catch (e) {
          console.warn("Invalid or truncated integrations JSON:", e);
        }
        const ringCentralIntegration = Array.isArray(integrations)
          ? integrations.find(
              (integration) => integration?.attribute_5 === 'Ring Central'
            )
          : null;
        if (ringCentralIntegration) {
          localStorage.setItem(
            'ringCentralIntegration',
            JSON.stringify(ringCentralIntegration)
          );
        }
        dispatch(updateAuth(userData[0]));
        try {
          const customMessagesRes = await dispatch(getCustomMessagesAsync(userData[0]?.id));
          if (customMessagesRes?.status === 200 && customMessagesRes?.data?.custommessageData?.length > 0) {
            let loginMessage = customMessagesRes.data.custommessageData.filter((x) =>
              location.pathname.toLowerCase().includes(x.contentType?.toLowerCase()?.replace("_", "/"))
            );
            if (loginMessage && loginMessage.length > 0 && loginMessage[0]?.message) {
              let msgToStore = typeof loginMessage[0]?.message === "object" ? JSON.stringify(loginMessage[0]?.message) : loginMessage[0]?.message;
              Cookies.set("loginMessage", msgToStore);
            }
          }
          await dispatch(fetchATSThemeConfig(userData[0]?.id)).unwrap();
        } catch (error) {
          console.warn("⚠️ Theme fetch failed, applying default theme.");
        }

        // Apply theme if present

        // if (userData.theme) {
        //   localStorage.setItem('themeSettings', JSON.stringify(userData.theme));
        //   setTheme(userData.theme);
        //   if (userData.theme.logo) {
        //     setLogoUrl(userData.theme.logo);
        //   }
        // }

        // Store custom messages if present

        // if (userData.customMessages) {
        //   Cookies.set('loginMessage', JSON.stringify(userData.customMessages));
        // }

        dispatch(updateLoader(false));
        if (userData[0].systemroles === "Field Recruiter") {
          navigate("/ats/layout/applicants/list/landing");
        } else {
          navigate("/ats/layout/dashboard");
        }
      } else if (response.userDetails.length === 0) {
        dispatch(resetStore());
        await persistor.flush();
        await persistor.purge();
        sessionExpired(
          "It looks like your account has been locked or disabled. You won’t be able to log in until it’s reactivated. Please contact your company administrator for help.",
        );
      }
    } catch (error) {
      dispatch(updateLoader(false));

      if (error.response?.status === 401) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Invalid email or password",
          }),
        );
      } else if (
        error.response?.status === 400 ||
        error.response?.status === 403
      ) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: error.response?.data?.message,
          }),
        );
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Incorrect password. Please try again.",
          }),
        );
      }
    }
  };

  useEffect(() => {
    if (GetCustomMessages?.length > 0) {
      let loginMessage = GetCustomMessages.filter((x) =>
        location.pathname.toLowerCase().includes(x.contentType?.toLowerCase()?.replace("_", "/")),
      );
      if (loginMessage && loginMessage.length > 0 && loginMessage[0]?.message) {
        let msgToStore = typeof loginMessage[0]?.message === "object" ? JSON.stringify(loginMessage[0]?.message) : loginMessage[0]?.message;
        Cookies.set("loginMessage", msgToStore);
      }
    }
  }, [GetCustomMessages, location.pathname]);

  useEffect(() => {
    const storedTheme = localStorage.getItem("themeSettings");
    if (storedTheme && Object.keys(storedTheme)?.length > 0) {
      const parsedTheme = JSON.parse(storedTheme);
      setTheme(parsedTheme);

      if (parsedTheme?.logo || themeSettings?.logo?.trim() !== "") {
        setLogoUrl(parsedTheme?.logo);
      } else {
        setLogoUrl(DEFAULT_LOGO);
      }
    } else {
      setLogoUrl(DEFAULT_LOGO);
      setTheme(DefaultTheme);
    }
    setIsLogoLoading(false);

    let customMessage = Cookies.get("loginMessage");
    if (customMessage && customMessage !== "undefined") {
      //  console.log(JSON.parse(customMessage));
      const resultObject = {};
      JSON.parse(customMessage)?.forEach((item) => {
        resultObject[item.heading.toLowerCase()] = item.data;
      });
      setCustomMessage(resultObject);
    }
  }, []);

  const handleChange = (e) => {
    let value = e.target.value;
    // if(e.target.name === "username"){
    //   value = value.trim()
    // }
    setUserDetails((userDetails) => ({
      ...userDetails,
      [e.target.name]: value.trim(),
    }));
    // setResetPasswordState((userDetails) => ({ ...resetPasswordState, [e.target.name]: e.target.value }))
    formik.values[e.target.name] = value.trim();
  };

  return (
    <>
      <div className="login-page">
        <div className="login-page__left-container">
          <img
            src={process.env.PUBLIC_URL + "/assests/img/login-icon-1.svg"}
            height={80}
            width={60}
            alt="HireWing"
            className="login-page__icon-1"
          />
          <img
            src={process.env.PUBLIC_URL + "/assests/img/login-icon-2.svg"}
            height={80}
            width={60}
            alt="HireWing"
            className="login-page__icon-2"
          />
          <img
            src={process.env.PUBLIC_URL + "/assests/img/login-icon-3.svg"}
            height={80}
            width={60}
            alt="HireWing"
            className="login-page__icon-3"
          />
          <img
            src={process.env.PUBLIC_URL + "/assests/img/login-icon-4.svg"}
            height={80}
            width={60}
            alt="HireWing"
            className="login-page__icon-4"
          />
          <img
            src={process.env.PUBLIC_URL + "/assests/img/login-icon-4.svg"}
            height={80}
            width={60}
            alt="HireWing"
            className="login-page__icon-5"
          />
          <div className="login-page__platform-info">
            <div className="login-page__platform-info-logo">
              {/* <img src={process.env.PUBLIC_URL + "/assests/img/Hirewing-logo.png"} alt="Hirewing logo" /> */}
              <img
                src={
                  logoUrl
                    ? logoUrl
                    : process.env.PUBLIC_URL + "/assests/HireWing.png"
                }
                alt="Company logo"
                className={logoUrl ? "customLogo" : "hirewingImg"}
              />
            </div>
            <div className="login-page__platform-info-heading">
              {customMessage.heading
                ? customMessage.heading
                : "AI-Driven Recruitment Platform"}
            </div>
            <div className="login-page__platform-info-subtext">
              {customMessage.body
                ? customMessage.body
                : "Let HireWing's advanced technology transform the way you recruit, making it easier and more efficient to find the perfect match for your organization."}
            </div>
            <div className="login-page__platform-info-illustration">
              {/* <img src={process.env.PUBLIC_URL + "/assests/img/hirewing-illustration.svg"} alt="Illustration" /> */}
              <Loginillu primaryColor={appTheme?.primaryColor} />
            </div>
          </div>
        </div>
        {showMessage !== "" ? (
          <MessageBar message={showMessage} type={showMsgType} />
        ) : (
          ""
        )}
        {showLoader ? <Loader /> : ""}
        <div className="login-page__right-section">
          <div className="login-page__mobile-section">
            <div className="login-page__mobile-top">
              <div className="login-page__platform-info-logo-mobile">
                <img
                  src={
                    logoUrl
                      ? logoUrl
                      : process.env.PUBLIC_URL +
                        "/assests/img/Hirewing-logo.png"
                  }
                  alt="Hirewing logo"
                  className={logoUrl ? "customLogo" : ""}
                />
              </div>
              <div className="login-page__mobile-icons">
                <img
                  src={process.env.PUBLIC_URL + "/assests/img/login-icon-1.svg"}
                  alt=""
                  className="login-page__mobile-icon-sm"
                />
                <img
                  src={process.env.PUBLIC_URL + "/assests/img/login-icon-2.svg"}
                  alt=""
                  className="login-page__mobile-icon-lg"
                />
              </div>
            </div>
            <div className="login-page__platform-info-heading-mobile">
              {customMessage.heading
                ? customMessage.heading
                : "AI-DRIVEN RECRUITMENT PLATFORM"}
            </div>
          </div>
          {resetPasswordState.isPromptOpen === false ? (
            <>
              <FocusError formik={formik} />
              <div className={`login-page__form ${isMobile ? "" : "h600"}`}>
                <div className="text-center">
                  <div className="usericon_div">
                    {/* <img src={process.env.PUBLIC_URL + "/assests/userIcon3.svg"} alt="" className='login-page__user-icon' /> */}
                    <UserIcon3
                      primaryColor={appTheme?.primaryColor}
                      primaryFontColor={appTheme?.primaryFontColor}
                    />
                  </div>

                  <h3 className="login-page__form-heading">
                    {isMobile && (
                      <span
                        style={{ color: "var(--primary-bg-color, #FFD800)" }}
                      >
                        ATS{" "}
                      </span>
                    )}
                    Sign In
                  </h3>
                  <form
                    onSubmit={formik.handleSubmit}
                    className="d-flex justify-content-start flex-column text-left m-2 login-page__form-inputs"
                  >
                    <div className="linewidth">
                      <FormControl variant="standard" fullWidth>
                        <Input
                          placeholder="E-mail address"
                          id="input-with-icon-adornment"
                          // type="email"
                          name="username"
                          value={userDetails.username}
                          onBlur={formik.handleBlur}
                          error={
                            formik.errors.username && formik.touched.username
                              ? true
                              : false
                          }
                          onChange={handleChange}
                          startAdornment={
                            <InputAdornment position="start">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assests/usericon2.svg"
                                }
                                alt="user icon"
                              />
                            </InputAdornment>
                          }
                        />
                        {formik.errors.username && formik.touched.username ? (
                          <FormHelperText className="errorHelperText">
                            {formik.errors.username}
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </div>
                    <div className="linewidth">
                      <FormControl variant="standard" fullWidth>
                        <Input
                          placeholder="Password"
                          id="input-with-icon-adornment"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          // autoComplete="off"
                          value={userDetails.password}
                          onChange={handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.errors.password && formik.touched.password
                              ? true
                              : false
                          }
                          startAdornment={
                            <InputAdornment position="start">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assests/lockicon.svg"
                                }
                                alt="lock icon"
                              />
                            </InputAdornment>
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {formik.errors.password && formik.touched.password ? (
                          <FormHelperText className="errorHelperText">
                            {formik.errors.password}
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ width: "100%" }}
                    >
                      <div className="remforget">
                        <input
                          style={{ height: "17px", width: "17px" }}
                          type="checkbox"
                          checked={remember}
                          onChange={(e) => {
                            setRemember(e.target.checked);
                          }}
                          id="rememberMe"
                        />{" "}
                        <label
                          className="rembtext"
                          htmlFor="rememberMe"
                          style={{
                            cursor: "pointer",
                            color: "#3B4046",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Remember me
                        </label>
                      </div>
                      <div>
                        <Link to="/ats/forgotpassword" className="forgotlink">
                          Forgot password ?
                        </Link>
                      </div>
                      {/* <Link to="/ats/reset-password" className='forgotlink'>reset Password ?</Link> */}
                    </div>
                    <div className="text-center terms-conditions">
                      <p style={{ color: "#3B4046" }}>
                        By signing in, I agree to the HireWing's{" "}
                      </p>
                      <h4>
                        <a
                          href="https://www.hirewing.com/general-4"
                          target="_blank"
                        >
                          Privacy Policy
                        </a>{" "}
                        and{" "}
                        <a
                          href="https://www.hirewing.com/copy-of-privacy-policy-cookies"
                          target="_blank"
                        >
                          Terms & Conditions
                        </a>{" "}
                      </h4>
                    </div>
                    <div className="btnSection">
                      <Button
                        type="submit"
                        className="btn-submitlogin"
                        size="medium"
                        variant="outlined"
                      >
                        Submit
                      </Button>
                    </div>
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <p className="errorHelperText text-center">
                        {serviceErrorMsg}
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </>
          ) : (
            <div className={`login-page__form ${isMobile ? "" : "h600"}`}>
              <div className="text-center">
                <img
                  src={process.env.PUBLIC_URL + "/assests/userIcon3.svg"}
                  alt=""
                  className="login-page__user-icon"
                />
                <h2 className="newPasswordText">New Password</h2>
                <form
                  // onSubmit={handleSubmit}
                  onSubmit={handleResetPassword}
                  className="d-flex justify-content-start flex-column text-left"
                  style={{ margin: isMobile ? "4% 6% 0% 6%" : "9% 10% 0% 10%" }}
                >
                  <div
                    className="linewidth"
                    style={{
                      width: "100%",
                      minHeight: "75px",
                      marginTop: "10px",
                    }}
                  >
                    <FormControl variant="standard" fullWidth>
                      <Input
                        placeholder="New password"
                        id="input-with-icon-new-password"
                        type={showNewPassword ? "text" : "password"}
                        required
                        name="newpassword"
                        margin="dense"
                        value={resetPasswordState.newPassword}
                        onChange={(e) =>
                          onConfirmpasswordHandler(
                            e.target.value,
                            "newPassword",
                            resetPasswordState,
                          )
                        }
                        startAdornment={
                          <InputAdornment position="start">
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/lockicon.svg"
                              }
                              alt="lock icon"
                            />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              onClick={() =>
                                setShowNewPassword(!showNewPassword)
                              }
                            >
                              {showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {resetPasswordState.passwordPattern ? (
                        <FormHelperText className="errorHelperText">
                          {resetPasswordState.passwordPattern}
                        </FormHelperText>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </div>
                  <div
                    className="linewidth"
                    style={{
                      marginTop: "10px",
                      width: "100%",
                      minHeight: "55px",
                    }}
                  >
                    <FormControl variant="standard" fullWidth>
                      <Input
                        placeholder="Confirm password"
                        margin="dense"
                        id="input-with-icon-confirm-password"
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmpassword"
                        autoComplete="off"
                        value={resetPasswordState.confirmPassword}
                        onChange={(e) =>
                          onConfirmpasswordHandler(
                            e.target.value,
                            "confirmPassword",
                            resetPasswordState,
                          )
                        }
                        startAdornment={
                          <InputAdornment position="start">
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/lockicon.svg"
                              }
                              alt="lock icon"
                            />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {resetPasswordState.error ? (
                        <FormHelperText className="errorHelperText">
                          {resetPasswordState.error}
                        </FormHelperText>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </div>
                  <div className="btnSection" style={{ paddingTop: "17px" }}>
                    <Button
                      onClick={handleResetPassword}
                      className="btn-submitlogin"
                    >
                      Submit
                    </Button>
                    <Link
                      type="button"
                      onClick={handleResetPasswordClose}
                      className="linktologin"
                      style={{ marginTop: isMobile ? "10px" : "15px" }}
                    >
                      Back to login
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          )}
          <div className="login-page__mobile-illustration">
            <Loginillu primaryColor={appTheme?.primaryColor} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
